import * as React from "react";
import { Button, DataListAction, DataListCell, DataListItem, DataListItemCells, DataListItemRow } from "@patternfly/react-core";
import { Divider, Dropdown, DropdownItem, DropdownList, MenuToggle } from "@patternfly/react-core";
import { EditIcon, EllipsisVIcon, EyeIcon, FlagIcon, TimesIcon } from "@patternfly/react-icons";

export const RoleDataListItem = ({ role, isOpen, setIsOpen, onSelect, onToggle, onEdit, onDelete, onView }) => {

  return (
    <DataListItem key={role.id} aria-labelledby={role.id}>
      <DataListItemRow>
        <DataListItemCells
          dataListCells={[
            <DataListCell key="icon" isFilled={false}>
              <FlagIcon />
            </DataListCell>,
            <DataListCell key="name">
              <Button size="sm" variant="link" isInline onClick={() => onEdit(role?.id)}>{role?.name}</Button>
            </DataListCell>,
            <DataListCell key="description">
              {role.description}
            </DataListCell>
          ]}
        />
        <DataListAction isPlainButtonAction>
          <Dropdown
            popperProps={{ position: 'right' }}
            onOpenChange={(isOpen) => { if (isOpen) setIsOpen(role.id); else setIsOpen(0) }}
            onSelect={ onSelect }
            isOpen={(isOpen === role.id)}
            toggle={(toggleRef) => (
              <MenuToggle
                ref={toggleRef}
                isExpanded={isOpen === role.id}
                onClick={() => onToggle(role.id)}
                variant="plain"
                aria-label="Date List Item Action"
              >
                <EllipsisVIcon aria-hidden="true" />
              </MenuToggle>
            )}
          >
            <DropdownList>
              <DropdownItem key="view" icon={<EyeIcon />} onClick={() => onView(role.id)}>View</DropdownItem>
              <DropdownItem key="edit" icon={<EditIcon />} onClick={() => onEdit(role.id)}>Edit</DropdownItem>
              <Divider key="sep1"></Divider>
              <DropdownItem key="delete" icon={<TimesIcon />} onClick={() => onDelete(role.id)}>Delete</DropdownItem>
            </DropdownList>
          </Dropdown>
        </DataListAction>
      </DataListItemRow>
    </DataListItem>
  );

};